import React from 'react';
import '../../assets/styles/LoginRegister.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import WxLogin from './WxLogin'; // 导入微信登录组件

const Login = () => {
    return (
        <div className="login-register-container">
            <WxLogin />
            <ToastContainer />
        </div>
    );
};

export default Login;